import { Node } from '@antv/x6';
import styles from './index.module.scss';
const VirtualGrid = ({ node }: { node: Node }) => {
  return <div className={styles.virtual_grid_box}></div>;
};

export default VirtualGrid;
